interface ErrorProps {
  error?: ValidityState;
  fieldName?: string;
}

export const Error = ({ error, fieldName }: ErrorProps) => {
  if (!error || error.valid) return null;
  let message = '';
  let isCustom = false;
  if (error.tooShort) message = `es demasiado corto`;
  if (error.tooLong) message = `es demasiado largo`;
  if (error.patternMismatch) message = `debe tener un formato válido`;
  if (error.valueMissing) message = `es requerido`;
  if (error.customError) message = `es invalido`;
  if (error.typeMismatch) message = `debe tener un formato válido`;
  if ((error as any).customMsg) {
    message = (error as any).customMsg as string;
    isCustom = true;
  }

  return (
    <div className="text-xs text-red-800">
      {!isCustom && <span className="mr-1 capitalize">{fieldName ?? 'El campo'}</span>}
      {message}
    </div>
  );
};
